import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { GroupDto, UpdateUserDto, UserDto } from '@oracychampions/api-interfaces';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private http = inject(HttpClient);

  refresh$ = new BehaviorSubject(null);
  refreshUserGroups$ = new BehaviorSubject(null);

  reloadUsers() {
    this.refresh$.next(null);
  }

  reloadUserGroups() {
    this.refreshUserGroups$.next(null);
  }

  getUsers(schoolId: string | null): Observable<UserDto[]> {
    return this.refresh$.pipe(
      switchMap(() =>
        schoolId
          ? this.http.get<UserDto[]>(`${environment.API}/schools/${schoolId}/users`)
          : this.http.get<UserDto[]>(`${environment.API}/users`),
      ),
    );
  }

  getUserGroups(id: string): Observable<GroupDto[]> {
    return this.refreshUserGroups$.pipe(
      switchMap(() => this.http.get<GroupDto[]>(`${environment.API}/users/${id}/groups`)),
    );
  }

  createUser(user: UpdateUserDto): Observable<UserDto[]> {
    return this.http.post<UserDto[]>(`${environment.API}/users`, user);
  }

  updateUser(id: string, user: UpdateUserDto): Observable<UserDto[]> {
    return this.http.patch<UserDto[]>(`${environment.API}/users/${id}`, user);
  }

  deleteUser(id: string): Observable<any> {
    return this.http.delete<UserDto[]>(`${environment.API}/users/${id}`);
  }
}
